import React from 'react'
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { clearStatus } from "./quotaCopySlice";

const alertFontSize = "15px";

function SharedComponent() {
    const dispatch = useDispatch();
    const states = useSelector((state) => state.quotaCopy);
    const {
        isSuccess,
        isSuccessMsg,
        isInfo,
        isInfoMsg,
        isError,
        isErrorMsg,
    } = states;

    const handleCloseSnackbar = () => {
        dispatch(clearStatus());
    };

    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={isSuccess}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} variant="filled" severity="success" sx={{ width: "100%", fontSize: alertFontSize }}>
                    {isSuccessMsg}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={isInfo}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} variant="filled" severity="warning" sx={{ width: "100%", fontSize: alertFontSize }}>
                    {isInfoMsg}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={isError}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} variant="filled" severity="error" sx={{ width: "100%", fontSize: alertFontSize }}>
                     {isErrorMsg}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default SharedComponent
